define(function (require) {

    var BaseEngagementWidget = require('web-agent-widgets/BaseEngagementWidget');
    var WebAgentUtils = require('web-agent-utils/WebAgentUtils');

    var EngagementsHistoryEngagementWidget = BaseEngagementWidget.extend({
        ControllerName: "EngagementsHistoryEngagementWidget",
        applicationType: "EngagementsHistoryEngagementWidget",

        LPViewMap : {
        },

        initialize : function (constructorData) {
        },

        events : function () {
        },

        render : function () {
        }
    });

    EngagementsHistoryEngagementWidget.prototype.onSelectedEngagementChanged = function (data) {
        var that = this;
        var engagementData = data.newValue.eventData;

        this.engagementVC.removeLoading();

        if(engagementData && engagementData.isPartial && engagementData.engagementId) {
            var engagementId = WebAgentUtils.extractRtEngagementId(engagementData.engagementId, engagementData.engagementSequence);
            this.engagementVC.setLoading();
            this.engagementVC.removeErrorState();
            this.modelController.searchEngagementById(engagementId,
                function success() {
                    that.engagementVC.removeLoading();
                    updateSelectedEngagementData.call(that, data);
                },
                function error() {
                    //data was not changed - fallback to partial data
                    that.engagementVC.removeLoading();
                    updateSelectedEngagementData.call(that, data);
                }
            );
        } else {
            updateSelectedEngagementData.call(this, data);
        }

    };

    function updateSelectedEngagementData(data) {
        if (this.widgetsManager.selectedItemId) {
            this.engagementVC.setOfflineChatId(this.widgetsManager.selectedItemId, true);
        }
        BaseEngagementWidget.prototype.onSelectedEngagementChanged.call(this, data);
    }

    return EngagementsHistoryEngagementWidget;

});
